import { RuntimeNotifier, Terminator } from "@opendaw/lib-std";
import { Runtime } from "@opendaw/lib-runtime";
import { StudioPreferences } from "./StudioPreferences";
export class BufferUnderrunDetector {
    static CONSECUTIVE_THRESHOLD = 10;
    #terminator = new Terminator();
    #pollLifecycle;
    #playbackStats;
    #engine;
    #lastValue = 0;
    #consecutiveIncreases = 0;
    constructor(playbackStats, engine) {
        this.#playbackStats = playbackStats;
        this.#engine = engine;
        this.#pollLifecycle = this.#terminator.own(new Terminator());
        this.#terminator.own(engine.isPlaying.catchupAndSubscribe(owner => owner.getValue() ? this.#startPolling() : this.#stopPolling()));
    }
    #startPolling() {
        this.#pollLifecycle.terminate();
        this.#lastValue = this.#playbackStats.underrunEvents;
        this.#consecutiveIncreases = 0;
        this.#pollLifecycle.own(Runtime.scheduleInterval(() => this.#poll(), 1000));
    }
    #stopPolling() { this.#pollLifecycle.terminate(); }
    #poll() {
        const events = this.#playbackStats.underrunEvents;
        this.#consecutiveIncreases = events > this.#lastValue ? this.#consecutiveIncreases + 1 : 0;
        this.#lastValue = events;
        if (this.#consecutiveIncreases >= BufferUnderrunDetector.CONSECUTIVE_THRESHOLD) {
            this.#consecutiveIncreases = 0;
            this.#handleOverload();
        }
    }
    #handleOverload() {
        if (!StudioPreferences.settings.engine["stop-playback-when-overloading"]) {
            return;
        }
        this.#stopPolling();
        this.#engine.sleep();
        RuntimeNotifier.notify({ message: "Audio dropout. Playback stopped.", icon: "Info" });
    }
    terminate() { this.#terminator.terminate(); }
}
